import { Expander, useToggle } from "@evergis/ui";
import React, { FC } from "react";

import { StyleIcon } from "../../../../components/StyleIcon/StyleIcon";
import { formatNumber } from "../../../../utils/formatNumber";
import { useLayerItem } from "../../hooks/useLayerItem";
import { Content, IconContainer, ListItem, Main, Section } from "../../styled";
import { FeaturesSearchList } from "./FeaturesSearchList";
import { LayerControls, LayerName, Tag } from "./styled";

export interface LayersSearchResultsProps {
  layerName: string;
  foundObjects: number;
}

export const LayerSearchResults: FC<LayersSearchResultsProps> = ({ layerName, foundObjects }) => {
  const layerItemInfo = useLayerItem(layerName);
  const { layer, status } = layerItemInfo;
  const { geometryType = null, style, type, sourceType, alias } = layer;
  const symbolHasRasters = style && style.hasRasters();
  const symbolIsClassified = style && style.classificationManager.hasClassifications();
  const [expanded, toggleExpanded] = useToggle(false);

  return (
    <ListItem>
      <Main>
        <IconContainer>
          <StyleIcon
            error={status === "layerError"}
            warn={status === "tableError"}
            type={type}
            geometryType={geometryType as never}
            sourceType={sourceType}
            symbol={style && style.symbol}
            hasRasters={symbolHasRasters}
            hasClassification={symbolIsClassified}
          />
        </IconContainer>
        <Section>
          <Content>
            <LayerName>{alias || layerName}</LayerName>
            <LayerControls>
              <Tag>{formatNumber(foundObjects)}</Tag>
              <Expander onClick={toggleExpanded} isSelected={expanded} />
            </LayerControls>
          </Content>
        </Section>
      </Main>
      {expanded && <FeaturesSearchList layer={layer} totalCount={foundObjects} />}
    </ListItem>
  );
};
